export default {
  // 模式
  "common.mode.auto": "Modus for automatisk bruk av egenprodusert energi",
  "common.mode.economy": "Økonomisk modus",
  "common.mode.exigency": "Nødsituasjonsmodus",

  // 设备
  "common.grid": "Elektrisk nett",
  "common.evChargers": "Ladere for elektriske kjøretøy",
  "common.evCharger": "Lader for elektrisk kjøretøy",
  "common.pv": "Solenergi (fotovoltaikk, PV)",
  "common.inverter": "Omformer",
  "common.pcs": "Omformer + batteri",
  "common.terminal": "Terminalutstyr",
  "common.airc": "Klimaanlegg",
  "common.engine": "Motor",
  "common.battery": "Batteri",
  "common.metter": "Elektrisk måler",
  "common.other": "Annet",
  "common.power": "Effekt",
  "common.powerTotal": "Total effekt",
  "common.voltage": "Spenning",
  "common.electricity": "Elektrisk energi",
  "common.current": "Strøm",
  "common.homeUsage": "Total last i hjemmet",
  "common.battery.power": "Batterieffekt",

  // 数据
  "common.noDataAvailable": "Ingen data tilgjengelig for tiden~",
  "common.tips": "Tips",
  "common.reset": "Tilbakestill",
  "common.currencyUnit": "¥",
  "common.submiting": "Sender... Vennligst vent...",
  "common.close": "Lukk",
  "common.from": "Fra",
  "common.useIn": "For",
  "common.energyPercent": "Prosentandel av energi strøm",
  "common.dataFlow": "Dataflyt",
  "common.getDataIng": "Henter data... Vennligst vent...",
  "common.pageLoading": "Laster sideinnhold... Vennligst vent...",
  "common.reseting": "Tilbakestiller sideinnhold... Vennligst vent...",
  "common.save": "Lagre",
  "common.onlyNumberTips": "Kun tall kan innføres",
  "common.offline": "Offlinemodus",
  "common.online": "Onlinemodus",
  "common.fault": "Feil",
  "common.charge": "Lade",
  "common.discharge": "Utlade",
  "common.buy": "Kjøp",
  "common.sell": "Salg",
  "common.loadingInfo": "Laster... Vennligst vent...",

  // 通用功能
  "common.moreFeatures": "Flere funksjoner",
  "common.confirm": "Bekreft",
  "common.saveing": "Lagrer... Vennligst vent...",
  "common.searchPlacholder": "Skriv inn søkeord",
  "common.iSee": "Jeg forstår",
  "common.pageErrorTips1": "Oh, en feil oppstod på siden~",
  "common.pageErrorTips2": "Prøv å oppdatere siden eller kontakt støtte~",
  "common.refresh": "Oppdater",
  "common.backToHome": "Gå tilbake til hovedsiden",
  "common.checkTips": "Sjekker... Vennligst vent...",
  "common.back": "Tilbake",
  "common.cancel": "Avbryt",
  "common.optional": "Valgfritt",
  "common.required": "Påkrevd",
  "common.status": "Status",
  "common.statusNoDelete": "Ikke slettet",
  "common.statusDelete": "Slettet",
  "common.submit": "Send inn",
  "common.disable": "Deaktiver",
  "common.enable": "Aktiver",
  "common.year": "år",
  "common.month": "måned",
  "common.day": "dag",
  "common.version": "Versjon:",
  "common.backHome": " Gå tilbake til hovedsiden",
  "common.backHomeSorry": "Beklager, siden mistet veien ved en feil",
  "common.requestTips1": "Databehandling pågår, send ikke igjen",
  "common.requestTips2": "Systemvarslinger",
  "common.requestTips3": "Innloggingen er utløpt, vennligst logg inn igjen",
  "common.requestTips4": "Logg inn igjen",
  "common.requestTips5": "Ugyldig sesjon eller sesjon utløpt, vennligst logg inn igjen.",
  "common.requestTips6": "	Serverfeil, vennligst prøv igjen senere.",
  "common.requestTips7": "Tidsavbrutt for forespørsel til systemgrensesnitt",
  "common.requestTips8": "Systemgrensesnitt",
  "common.requestTips9": "Feil",
  "common.iknow": "Jeg forstår",
  "common.logoutSuccess": "Utlogging vellykket",
  
  // 了解更多组件
  "common.knowMore.title": "For mer informasjon, kontakt Beineng",
  "common.knowMore.email": "E-post for kontakt",
  "common.knowMore.phone": "Telefon for kontakt",
  "common.knowMore.wechat": "WeChat for kontakt",
  "common.knowMore.website": "Adresse til offisiell nettside",
  "common.knowMore.address": "Kontaktadresse",
  "common.knowMore.addressDetail": "Leiligheter 1205, 1301, Bygg 5, Qinghe-gaten 8, Huangjingkeng-bygg, Huangjiang-kommune, Dongguan-by, Guangdong-landsdel",
  
  // 本地连接组件
  "common.localConnection": "Lokal tilkobling",
  "common.operateInApp": "Utfør handlingen i appen!",
  
  "common.enbleStaus": "Aktiveringsstatus",
  "common.battery.status": "Ingen lading eller utladning",

  // 账户相关
  "account.forgetThePassword": "Glemt passord",
  "account.logInDirectly": "Logg inn direkte",
  "account.tips1": "Omdirigerer til siden... Vennligst vent...",
  "account.tips2": "Les og aksepter brukervilkårene først!",
  "account.autoLogin": "Automatisk innlogging",
  "account.userLogin": "Brukerinnlogging",
  "account.registerTips": "Har du ikke en konto ennå? Klikk her for å registrere deg",
  "account.userEmail": "Brukernavn / E-post",
  "account.userEmailTips": "Skriv inn brukernavn eller e-post",
  "account.password": "Passord",
  "account.passwordTips": "Skriv inn passord",
  "account.submit": "Send inn",
  "account.submitTips": "Sender... Vennligst vent...",
  "account.otherLoginTips": "Eller velg en annen innloggingsmetode",
  "account.userRegistration": "Brukerregistrering",
  "account.userName": "Brukernavn",
  "account.userNameTips": "Skriv inn brukernavn",
  "account.emailTips1": "Skriv inn e-postadresse",
  "account.emailTips2": "Ugyldig e-postformat",
  "account.phone": "Telefonnummer",
  "account.phoneTips1": "Skriv inn telefonnummer",
  "account.phoneTips2": "Ugyldig telefonnummer",
  "account.phoneTips3": "Skriv inn telefonnummer",
  "account.passwordTips1": "Skriv inn passord (6-30 tegn)",
  "account.passwordTips2": "Ugyldig passordformat: passordet må inneholde engelske bokstaver, tall, understreker, bindestreker og punktum, lengde 6-12 tegn",
  "account.passwordTips3": "De to innførte passordene samsvarer ikke, vennligst sjekk og skriv inn igjen!",
  "account.passwordTips4": "Skriv inn passord: passordet må inneholde engelske bokstaver, tall, understreker, bindestreker og punktum",
  "account.passwordTips5": "Bekreft passord",
  "account.passwordTips6": "Skriv inn passordbekreftelse",
  "account.passwordTips7": "De to innførte passordene samsvarer ikke, vennligst sjekk og skriv inn igjen!",
  "account.passwordTips8": "Skriv inn passordbekreftelse",
  "account.passwordTips9": "Gratulerer, registrering vellykket!",
  "account.passwordTips10": "Ditt brukernavn er:",
  "account.emailIs": "E-post er:",
  "account.goToLoginPage": "Du vil bli omdirigert automatisk til innloggingssiden om s sekunder",
  "account.goLogin": "Logg inn",
  "account.goRegister": "Registrer deg",
  "account.loginSuccess": "Innlogging vellykket",
  "account.email": "E-post",
  "account.sologn": "Vi lager en tilpasset energistrategi for deg med omhu",
  "account.pleaseAgree": "Jeg har lest og akseptert",
  "userAgreement.privacyPolicy": "personvernerklæring",

  // 验证码相关
  "account.code": "Verifiseringskode",
  "account.codeTips": "Skriv inn verifiseringskode",
  "account.codeTips2": "Ugyldig verifiseringskode",

    "account.inviteCodeTips": "Vennligst skriv inn invitasjonskode",
    "account.inviteCodeHint": "Kontakt installatøren eller driftspersonalet for å få invitasjonskoden",
  // 密码修改与恢复
  "account.modifyPasswordByAccount": "Endre passord via konto",
  "account.modifyPasswordByEmail": "Endre passord via e-post",
  "account.getPasswordByAccount": "Hent passord via konto",
  "account.getPasswordByEmail": "Hent passord via e-post",

  "account.sendEmailTips": "Verifiseringskoden er sendt til e-posten, vennligst sjekk",
  "account.name": "Kontonavn",
  "account.newPassword": "Nytt passord",
  "account.confirmNewPassword": "Bekreft nytt passord",
  "account.nameTips": "Skriv inn kontonavn",
  "account.passwordModifySuccess": "Passord endret vellykket",
  "account.emailCode": "E-postverifiseringskode",
  "account.emailCodeTips": "Skriv inn e-postverifiseringskode",
  "account.emailCodeTips2": "Ugyldig e-postverifiseringskode",
  "account.emailModifySuccess": "Passord endret vellykket",
  "account.passworTips1": "Ditt passord er tilbakestilt vellykket!",
  "account.passwordTips11": "Skriv inn passordbekreftelse",
  "account.passwordTips12": "Skriv inn nytt passord",
  "account.nickname": "Kallenavn",
  "account.modifyNickname": "Endre kallenavn",
  "account.modifyNicknameSuccess": "Kallenavn endret vellykket!",
  "account.nicknameTips": "Skriv inn kallenavn",
  "account.nicknameError": "Feil ved endring av kallenavn!",

  // 快速注册与登录
  "account.login": "Logg inn",
  "account.quickRegister": "Rask registrering",
  "account.sendCode": "Lähetä koodi",
  "account.sendTips": "Kan sendes igjen om s sekunder",
  "account.sendEmailIng": "Sender e-post... Vennligst vent...",
  "account.emailNotEmpty": "E-postadressen kan ikke være tom",
  "account.registerAccount": "Kontoregistrering",
  "account.registerWelcome": "Velkommen til registrering for SusprSafe",
  "account.usernameLimit": "Brukernavnet må starte med en bokstav og kan bare inneholde bokstaver, tall og understreker, lengde 5-15 tegn",

  // 版权信息
  "copyright.desc2": "Informasjon om nettsideregistrering: ICP-registrering for Guangdong nr. 2021169764",

  // 用户信息编辑
  "editUserInfo.editUserInformation": "Rediger brukerinformasjon",
  "editUserInfo.modifyUsername": "Endre brukernavn",
  "editUserInfo.changePictures": "Bytt profilbilde",
  "editUserInfo.savePicturesSuccess": "Profilbilde lagret vellykket",
  "editUserInfo.saveError": "Lagring feilet",
  "editUserInfo.pictureLimit": "Bildetstørrelsen må være mindre enn 2 MB",
  "editUserInfo.uploadPicture": "Last opp profilbilde",
  "editUserInfo.picturePreview": "Forhåndsvisning",
  
  "editUserInfo.bindPhoneNumber": "Bind telefonnummer",
  "editUserInfo.bindEmail": "Bind e-post",
  "editUserInfo.changePassword": "Endre passord",

  "editUserInfo.notificationSettings": "Varslingsinnstillinger",
  "editUserInfo.editAccount": "Rediger kontoinformasjon",
  "editUserInfo.waitBingting": "Binder... Vennligst vent...",
  "editUserInfo.collapse": "Skjul",
  "editUserInfo.modifyBinding": "Endre binding",
  
  "editUserInfo.emailAddress": "E-postadresse",
  "editUserInfo.tips1": "E-post bundet vellykket",
  "editUserInfo.tips2": "Lagring feilet",
  "editUserInfo.tips3": "Sender e-postverifiseringskode... Vennligst vent...",
  "editUserInfo.tips4": "Verifiseringskoden er sendt til e-post xxxx, vennligst sjekk",
  "editUserInfo.tips5": "Feil ved sending av verifiseringskode!",
  "editUserInfo.tips6": "Telefonnummeret er allerede bundet",
  "editUserInfo.tips7": "E-posten er allerede bundet",
  "editUserInfo.emailTips1": "Skriv inn e-postadresse",
  "editUserInfo.emailTips2": "Ugyldig e-postformat",
  "editUserInfo.emailTips3": "Kan sendes igjen om xxxx sekunder",
  "editUserInfo.emailTips4": "Lähetä koodi",
  "editUserInfo.emailTips5": "E-postverifiseringskoden kan ikke være tom",
  "editUserInfo.emailTips6": "Ugyldig e-postverifiseringskode",
  "editUserInfo.emailCode": "E-postverifiseringskode",
  "editUserInfo.save": "Lagre",

  // 手机绑定相关
  "editUserInfo.phoneTips1": "Telefonnummer bundet vellykket",
  "editUserInfo.phoneTips2": "Sender SMS-verifiseringskode... Vennligst vent...",
  "editUserInfo.phoneTips3": "SMS-verifiseringskoden er sendt til nummer xxxx, vennligst sjekk",
  "editUserInfo.phoneTips4": "Feil ved sending av SMS-verifiseringskode!",
  "editUserInfo.phoneTips5": "Skriv inn telefonnummer",
  "editUserInfo.phoneTips6": "Ugyldig telefonnummerformat",
  "editUserInfo.phoneTips7": "Send SMS-verifiseringskode",
  "editUserInfo.phoneTips8": "SMS-verifiseringskode",
  "editUserInfo.phoneTips9": "SMS-verifiseringskoden kan ikke være tom",
  "editUserInfo.phoneTips10": "Ugyldig SMS-verifiseringskode",
  "editUserInfo.phone": "Telefonnummer",


  // 通知设置
  "editUserInfo.noticeTips1": "Feil ved henting av varslingsinnstillinger!",
  "editUserInfo.noticeTips2": "Varslingsinnstillinger lagret vellykket!",
  "editUserInfo.noticeTips3": "Varsling om lav batterinivå",
  "editUserInfo.noticeTips4": "Varsling om fullført lading",
  "editUserInfo.errorNotification": "Feilvarsling",
  "editUserInfo.updateNotification": "Oppdateringsvarsling",
  "editUserInfo.monthlyStatisticsNotification": "Varsling om månedlig statistikk",
  "editUserInfo.notificationMethod": "Mottaksmetode",

  // 用户名相关提示
  "editUserInfo.userNameTips1": "Brukernavn lagret vellykket",
  "editUserInfo.userNameTips2": "Lagring av brukernavn feilet",
  "editUserInfo.userNameTips3": "Skriv inn brukernavn",
  "editUserInfo.userNameTips4": "Ugyldig brukernavnformat: kan bare inneholde tall, understreker og engelske bokstaver",
  "editUserInfo.userNameTips5": "Skriv inn brukernavn",
  "editUserInfo.userNameTips6": "Lagrer... Vennligst vent...",
  "editUserInfo.userName": "Brukernavn",

  // 头像编辑提示
  "editUserInfo.avatorTips": "Klikk for å bytte profilbilde",
  "editUserInfo.verifyCodeTips1": "Skriv inn den mottatte verifiseringskoden:",
  "editUserInfo.verifyCodeTips2": "For kontoens sikkerhet, klikk på knappen nedenfor for å sende verifiseringskode til det opprinnelige telefonnummeret:",
  "editUserInfo.verifyCodeTips3": "Lähetä koodi",
  "editUserInfo.verifyCodeTips4": "Verifisering av opprinnelig telefonnummer vellykket, skriv inn det nye bundne telefonnummeret",
  "editUserInfo.verifyCodeTips5": "For kontoens sikkerhet, klikk på knappen nedenfor for å sende verifiseringskode til den opprinnelige e-posten:",
  "editUserInfo.verifyCodeTips6": "Verifisering av opprinnelig e-post vellykket, skriv inn den nye e-posten",
  "editUserInfo.verifyCodeTips7": "Gammelt passord",
  "editUserInfo.verifyCodeTips8": "Bind e-posten først!",
  "editUserInfo.verifyCodeTips9": "Verifiseringskoden er sendt til e-posten, vennligst sjekk",
  "editUserInfo.verifyCodeTips10": ", du vil bli omdirigert automatisk til innloggingssiden",

  // 通知相关
  "hems.notice.title": "Varslingstittel", 
  "hems.notice.content": "Varslingsinnhold", 
  "hems.notice.operate": "Handling",
  "hems.notice.noRead": "Ikke lest",
  "hems.notice.read": "Lest",
  "hems.notice.warning": "Advarsel",
  "hems.notice.error": "Feil",
  "hems.notice.success": "Statistikkberegning",
  "hems.notice.sys": "Systeminformasjon",
  "hems.notice.operateSuccess": "Handling vellykket",
  "hems.notice.operateTips": "Velg element for handling",

  // 首页
  "hems.home.selfuseRate": "Egenbruksrate",
  "hems.home.percent": "Prosent",
  "hems.home.todayData": "Dagens data",
  "hems.home.todayPowerGeneration": "Dagens energiproduksjon",
  "hems.home.salesIncome": "Inntekt fra salg av energi",
  "hems.home.saved": "Du har spart",
  "hems.home.reduce": "Reduser kullstoffavtrykk",
  "hems.home.tips1": "Ingen data tilgjengelig for tiden, du har ikke bundet xxxx ennå",
  "hems.home.criticalLoad": "Kritisk last",
  "hems.home.keyVoltage": "Kritisk spenning",
  "hems.home.householdLoad": "Husholdningslast",
  "hems.home.householdVoltage": "Husholdningsspenning",
  "hems.home.generalLoad": "Generell last",
  "hems.home.generalVoltage": "Generell spenning",
  "hems.home.batteryHealth": "Batterihelsetilstand",
  "hems.home.averageTemp": "Gjennomsnittlig temperatur",
  "hems.home.gridLoad": "Nettlast",
  "hems.home.toggeleDataSource": "Visne data endret til:",
  "hems.home.toggleTips": "Er du sikker på at du vil endre?",
  "hems.home.modeSending": "Sender moduskommando... Vennligst vent...",
  "hems.home.modeSuccess": "Moduskommando sendt vellykket!",
  "hems.home.isOnline": "Er du online?",
  "hems.home.useStatus": "Brukstatus",
  "hems.home.workModeText": "Nåværende driftsmodus:",
  "hems.home.toggleDataSourceText": "Visne data endret til:",
  "hems.ev.charge.status": "Ladestatus",
  "hems.ev.charge.time": "Ladetid",
  "hems.ev.charge.count": "Reell lademengde",
  "hems.ev.charge.status.empty": "Tomt",
  "hems.ev.charge.status.ing": "Lader med tilkoblet kabel",
  "hems.ev.charge.status.null": "Kabel tilkoblet, men ingen lading",
  "hems.ev.charge.status.error": "Feil",
  "hems.hour": "time",
  "hems.minue": "minutt",
  "hems.ev.chagre.number": "Lader nummer",

  // 用户指南
  "hems.userGuide.selfUse": "Bruk av egenprodusert energi",
  "hems.userGuide.selfUseTips": "Bruk solenergi først; hvis det ikke er nok, kompletter med nettet",
  "hems.userGuide.economyMode": "Økonomisk modus",
  "hems.userGuide.economyModeTips": "Optimaliser strategi for energibruk etter elektrisk energipris",
  "hems.userGuide.emergencyMode": "Nødsituasjonsmodus",
  "hems.userGuide.emergencyModeTips": "Prioriter forsynning til kritisk last først",

  // 图表页面
  "hems.history.energyStatistics": "Energistatistikk",
  "hems.history.revenueStatistics": "Inntektstatistikk",
  "hems.history.greenStatistics": "Grønn reduksjon",
  "hems.history.revenueTitle": "Total inntekt fra salg av energi",
  "hems.history.savingsTitle": "Total sparing",
  "hems.history.carbonTitle": "Total kullstoffreduksjon",
  "hems.history.day": "dag",
  "hems.history.month": "måned",
  "hems.history.year": "år",
  "hems.history.beforeDay": "Forrige dag",
  "hems.history.afterDay": "Neste dag",
  "hems.history.beforeMonth": "Forrige måned",
  "hems.history.afterMonth": "Neste måned",
  "hems.history.beforeYear": "Forrige år",
  "hems.history.afterYear": "Neste år",
  "hems.history.totalUse": "Total bruk",
  "hems.history.fullScreen": "Fullskjerm",
  "hems.history.timeSelect": "Velg dato",
  "sync.tips1": "Data synkroniseringskommando sendt vellykket!",
  "sync.tips2": "Data synkronisering pågår; på grunn av stor datamengde trengs tid, sjekk igjen om en halv time~",
  "sync.tips3": "Data synkronisering for utstyr kan ha forsinkelse; hvis du ser uoverensstemmelser i data, klikk på:",
  "sync.tips4": "Synkroniser data",

  // 充电桩信息
  "charge.info": "Informasjon om lader",
  "news.loading": "Laster...",
  "news.noMore": "Ingen flere data",
  "hems.pv.power": "Mengde solenergi",

  // UEH特定功能
  "ueh.sellPower": "Mengde solgt energi",
  
  // 菜单
  "menu.home": "Hovedside",
  "menu.history": "Historiske data",
  "menu.device": "Utstyr",
  "menu.settings": "Innstillinger",
  "menu.messageCenter": "Meldingssenter",
  "menu.help": "Hjelp og støtte",
  "menu.mine": "Min",


  // 我的设置
  "mine.userSetting": "Brukerinnstillinger",
  "mine.terminalSetting": "Grunnleggende terminalinnstillinger",
  "mine.uploadCloud": "Last opp data til skyen",
  "mine.changeVersion": "Sjekk for oppdateringer",
  "mine.language": "Bytt språk",
  "mine.about": "Om appen",
  "mine.feedback": "Tilbakemelding",
  "mine.logout": "Logg ut",
  "mine.logoutAccount": "Slett konto",

  // 注销账户相关
  "mine.logoutAccountTips": "Slett konto med navn []",
  "mine.logoutAccountTips1": "Slett konto bundet til []",
  "mine.logoutAccountCare": "Notater om forespørsel om konto sletting:",
  "mine.logoutAccountCare1": "1. Kontoen er i sikker tilstand",
  "mine.logoutAccountCare1-1": "Kontoen er i normal driftsmodus, ingen risiko for tyveri, brudd på regler eller sperring.",
  "mine.logoutAccountCare2": "2. Autorisasjoner og bindinger for kontoen er fjernet",
  "mine.logoutAccountCare2-1": "Alle autorisasjoner for kontoen til tredjepart plattformer er fjernet.",
  "mine.logoutAccountCare3": "3. Etter sletting er kontoen ikke gjenopprettbar, brukerdata vil bli slettet",
  "mine.logoutAccountCare3-1": "Etter sletting vil bundne telefonnumre, e-poster og andre data bli slettet og ikke gjenopprettet.",
  "mine.confirmLogout": "Bekreft sletting",
  "mine.logoutSuccess": "Konto slettet vellykket!",


  // 反馈问题
  "mine.feedbackIssues": "Tilbakemelding om problemer",
  "mine.feedQuantity": "Antall",
  "mine.feedAmount": "Maks 9 bilder, maks størrelse 1 MB per bilde",

  // 通知设置相关
  "mine.notice.fail": "Feil ved henting av varslingsinnstillinger!",
  "mine.notice.saveSuccess": "Varslingsinnstillinger lagret vellykket!",
  "mine.notice.saveFail": "Lagring feilet!",
  "mine.notice.title": "Varslingsinnstillinger",
  "mine.notice.batteryLow": "Varsling om lav batterinivå",
  "mine.notice.chargingFinish": "Varsling om fullført lading",
  "mine.notice.error": "Feilvarsling",
  "mine.notice.update": "Oppdateringsvarsling",
  "mine.notice.monthly": "Varsling om månedlig statistikk",
  "mine.notice.receiveType": "Mottaksmetode",

  // 语言设置欢迎语
  "mine.language.welcome": "Velkommen til SusprSafe",
  "mine.language.desc1": "Velg språkversjon etter bosted",
  "mine.language.desc2": "Du kan endre det når som helst i appinnstillinger",

  // 个人信息
  "mine.userInfo.avatar": "Profilbilde",
  "mine.userInfo.nickname": "Kallenavn",
  "mine.userInfo.password": "Passord",
  "mine.userInfo.changePassword": "Endre passord",
  "mine.userInfo.setPassword": "Sett passord",
  "mine.userInfo.phoneNumber": "Telefonnummer",
  "mine.userInfo.bindPhone": "Bind telefonnummer",
  "mine.userInfo.bindEmail": "Bind e-post",
  "mine.loginExpired": "Innloggingen er utløpt, vennligst logg inn igjen",
  "mine.userInfo.title": "Brukerinformasjon",
  "mine.userInfo.bind": "Bind",
  "mine.userInfo.modify": "Rediger",
  "mine.userInfo.modifyNickname": "Endre kallenavn",
  "mine.userInfo.userNickname": "Brukerkallenavn",
  "mine.userInfo.selectPic": "Velg bilde å laste opp",
  "mine.userInfo.saveSuccess": "Lagret vellykket",
  "mine.userInfo.uploadFail": "Opplastning feilet",
  "mine.userInfo.avatarSaveSuccess": "Profilbilde lagret vellykket",
  "mine.userInfo.nameTips1": "Kallenavnet kan ikke være tomt",
  "mine.userInfo.nameTips2": "Skriv inn kallenavn"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};